import React, { useCallback, useEffect, useState, useContext } from 'react';
import {
  Avatar,
  Button,
  Heading,
  Tooltip as SuperopsTooltip,
  ButtonGroup,
  Page
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import {
  getTranslatedText,
  Loader,
  withErrorBoundary,
  COMMON_CONSTANTS
} from '@nile/components';
import { injectIntl, FormattedMessage } from 'react-intl';
import TicketPropertiesCard from '@nile/banyan/src/Containers/CardContainers/TicketPropertiesCard';
import {
  RMMClient,
  GET_RUNBOOKS_TICKET_PROPERTY_META,
  GET_ENTITY_PROPERTIES,
  TicketClient
} from '@nile/graphql';
import { useLazyQuery, useQuery } from '@apollo/client';
import { cloneDeep } from 'lodash';

function transformUpdatePropertyData(input) {
  if (!input) {
    return [];
  }

  const result = [];

  if (input?.customFields) {
    for (const [key, value] of Object.entries(input?.customFields)) {
      result.push({ name: key, value: value });
    }
  }
  if (input) {
    for (const [key, value] of Object.entries(input)) {
      if (key !== 'customFields') {
        result.push({ name: key, value: value });
      }
    }
  }

  return result;
}

function UpdatePropertyContent(props) {
  const { intl, action, executeEntityFlowAction, handleModalClose } = props;

  const [context, setContext] = useState({
    value: {
      action: [
        {
          type: 'PROPERTY_UPDATE',
          data:
            transformUpdatePropertyData(
              action?.flowAction?.actionValueData.ticket
            ) || []
        }
      ]
    }
  });
  const [ticketFieldsMeta, setTicketFieldsMeta] = useState(null);

  const [actionValueData, setActionValueData] = useState(
    transformUpdatePropertyData(action?.flowAction?.actionValueData.ticket) ||
      []
  );

  const {
    loading: entitiesLoading,
    error: entitiesError,
    data: allEntities
  } = useQuery(GET_ENTITY_PROPERTIES);

  const { data: ticketUpdateData } = useQuery(
    GET_RUNBOOKS_TICKET_PROPERTY_META,
    {
      client: TicketClient,
      variables: {},
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      onCompleted(res) {
        // setSelectedItems(res);
        const ticketFieldsMetaTemp = {
          getTicketAutomationRuleMetaInfo: {
            actionGroups: {
              PROPERTY_UPDATE:
                res?.getTicketMetaForRunbookAction?.propertyUpdate
            }
          }
        };
        setTicketFieldsMeta(ticketFieldsMetaTemp);
      },
      onError() {
        toast('error', 'error.page.config.default.title');
      }
    }
  );

  const updateConditions = (conditions) => {
    setActionValueData(conditions);
  };

  function transformData(configData) {
    const data = cloneDeep(configData);
    const result = {};
    const customFields = {};

    data.forEach((item) => {
      if (item.name.startsWith('udf')) {
        customFields[item.name] = item.value;
      } else {
        result[item.name] = item.value;
      }
    });

    if (Object.keys(customFields).length > 0) {
      result.customFields = customFields;
    }

    return result;
  }

  const saveAction = useCallback(() => {
    const actionValue = {
      ticket: transformData(actionValueData)
    };
    executeEntityFlowAction(action?.flowAction?.actionId, actionValue);
  }, [actionValueData]);

  return (
    <Page
      title={getTranslatedText(intl, 'admin.eventTrigger.updateProp')}
      contentHeight="110px"
      fullWidth
      variant="secondary"
      primaryAction={
        <ButtonGroup spacing="loose">
          <Button plainSecondary onClick={handleModalClose}>
            <FormattedMessage id="common.cancel" />
          </Button>
          <Button
            primary
            icon={<SVGIcon name="Save" />}
            onClick={saveAction}
            loading={false}
          >
            <FormattedMessage id="common.save" />
          </Button>
        </ButtonGroup>
      }
    >
      <div className="p2040">
        {(entitiesLoading || !ticketFieldsMeta) && (
          <div className="min-height-200 min-width-600 flex center">
            <Loader />
          </div>
        )}
        {!entitiesLoading && allEntities && ticketFieldsMeta && (
          <TicketPropertiesCard
            context={context}
            allEntities={allEntities}
            ticketAutomationMeta={ticketFieldsMeta}
            intl={intl}
            handleUpdateParent={updateConditions}
            isRunBookAction
          />
        )}
      </div>
    </Page>
  );
}

export default withErrorBoundary(injectIntl(UpdatePropertyContent));
